import React from "react";
import { Table } from "react-bootstrap";
import { Bubble } from "ctia-ui";
import LabResultRowBattery from "components/labRequest/LabResultRowBattery";

const BatteryLabResultList = ({ list }) => {
  if (!list) return null;

  return (
    <div>
      <Bubble>
        You may enter the test results for a request by clicking on the{" "}
        <strong>Request ID</strong>.
      </Bubble>
      <Table striped condensed hover className="ctia-table">
        <thead>
          <tr>
            <th>Request ID</th>
            <th>Vendor</th>
            <th>Model Name/Number</th>
            <th>Authorization Type</th>
            <th>Request Type</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <LabResultRowBattery tableRows={list} />
        </tbody>
      </Table>
    </div>
  );
};

export default BatteryLabResultList;
